var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 267,
    viewBox: "0 0 259 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.8069 250.417C79.2888 252.621 80.3838 254.643 81.9657 256.251C83.5475 257.859 85.5517 258.988 87.7471 259.506C99.8092 262.335 116.869 266.449 134.359 266.746C151.059 267.031 176.383 249.163 151.911 237.104C134.859 228.696 104.834 232.806 88.1925 236.069C86.626 236.379 85.137 236.998 83.8133 237.891C82.4895 238.784 81.3575 239.933 80.4839 241.269C79.6102 242.606 79.0125 244.104 78.7259 245.675C78.4393 247.246 78.4695 248.858 78.8147 250.417H78.8069Z",
    fill: "#E3E6E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8548 225.331C24.5885 224.038 0.936949 206.33 9.39258 181.854C17.8482 157.378 46.9467 141.439 80.3628 138.024C113.779 134.609 153.627 112.587 159.781 98.0397C165.935 83.4925 187.633 56.2305 214.61 67.6518C241.586 79.0732 238.836 123.567 221.498 138.72C204.161 153.873 207.326 171.339 210.655 182.432C213.984 193.525 224.503 218.97 196.065 225.21C167.627 231.45 130.202 217.599 109.262 217.536C88.3222 217.474 46.2433 236.393 26.8548 225.331Z",
    fill: "#E3E6E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9456 103.119C10.89 110.602 14.1253 119.194 21.2211 123.047C27.8247 126.638 40.5784 131.511 53.1486 124.786C71.2281 115.115 67.8912 101.017 93.1018 94.8161C118.312 88.615 169.023 66.2451 178.674 47.9272C188.325 29.6093 177.842 14.1164 160.864 13.1825C143.886 12.2487 103.816 56.4883 89.7883 61.2984C75.7607 66.1084 21.862 85.4266 14.2269 102.459C14.1253 102.682 14.0315 102.901 13.9456 103.119Z",
    fill: "#E3E6E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6307 33.5715C56.1561 31.3091 61.4897 26.3467 63.9084 19.876C64.6078 18.0083 64.9751 16.1953 64.7172 14.687C63.6857 8.65005 70.2619 -1.72411 79.4638 0.643775C88.6657 3.01166 98.8289 39.5694 73.2119 56.3947C47.595 73.22 36.5566 58.6844 35.8532 54.863C35.2007 51.4244 30.8166 40.0851 49.6307 33.5715Z",
    fill: "#E3E6E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5321 83.5042C85.5321 83.5042 54.4799 88.4861 38.4557 104.995C22.4314 121.504 2.93342 169.28 2.93342 169.28C-1.5054 176.962 7.05573 190.212 22.0524 198.87C37.049 207.529 52.8037 208.315 57.2386 200.633C57.4112 200.33 57.5639 200.017 57.6957 199.695L57.7387 199.605L57.8208 199.382C57.8677 199.253 57.9146 199.124 57.9575 198.992L66.2334 175.899C86.7082 176.786 95.1951 147.441 95.1951 147.441L107.019 144.206L109.5 120.167L85.5321 83.5042Z",
    fill: "#A0D4E8",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8591 138.161L75.6692 148.578L74.3485 151.138C74.3485 151.138 63.7399 159.707 44.6796 156.323C25.6192 152.939 29.8627 189.755 12.166 191.736C15.1993 194.456 18.5101 196.85 22.0439 198.878C37.0406 207.533 52.7952 208.323 57.2301 200.641C57.4028 200.338 57.5555 200.025 57.6873 199.703L57.7303 199.613L57.8123 199.39C57.8592 199.261 57.9061 199.132 57.9491 198.999L66.225 175.907C86.6998 176.794 95.1867 147.449 95.1867 147.449L101.329 145.769L96.8591 138.161Z",
    fill: "#60B7D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1895 113.584C62.1895 113.584 78.0027 115.85 84.5164 110.981L92.7649 116.795L91.4325 122.074C91.4325 122.074 73.4115 126.794 62.1895 113.584Z",
    fill: "#60B7D8"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3574 64.4478C90.3574 64.4478 175.461 101.052 135.23 188.402L187.3 169.143C187.3 169.143 192.118 151.802 183.303 110.981C174.488 70.1604 137.098 48.6892 137.098 48.6892L90.3574 64.4478Z",
    fill: "#6C7A85",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3585 64.4478C90.3585 64.4478 59.3767 141.697 135.231 188.402C175.462 101.052 90.3585 64.4478 90.3585 64.4478Z",
    fill: "#A6B3BC",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M142.053 141.642C142.053 141.642 146.312 143.51 147.781 146.851C149.25 150.192 148.984 171.155 163.411 178.11L182.639 170.631L160.066 141.642L149.125 137.235L142.053 139.298V141.642Z",
    fill: "#5B6B78"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3901 69.5234C92.3901 69.5234 68.0313 142.486 132.988 182.498C167.463 107.675 92.3901 69.5234 92.3901 69.5234Z",
    fill: "#6C7A85",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.936 115.994L175 105.003",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.885 60.8998C100.885 60.8998 100.885 41.9528 104.968 29.1131C105.596 27.132 106.858 25.4125 108.56 24.2199C110.262 23.0272 112.308 22.4275 114.385 22.5135C115.825 22.5722 117.232 22.9592 118.5 23.6449C119.768 24.3307 120.862 25.297 121.699 26.4701C122.536 27.6432 123.095 28.9921 123.331 30.4138C123.567 31.8355 123.476 33.2924 123.063 34.6733C121.344 40.4524 119.914 47.6108 120.531 54.2768L100.885 60.8998Z",
    fill: "#6C7A85",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.885 60.8998C100.885 60.8998 100.885 41.9528 104.968 29.1131C105.596 27.132 106.858 25.4125 108.56 24.2199C110.262 23.0272 112.308 22.4275 114.385 22.5135C115.825 22.5722 117.232 22.9592 118.5 23.6449C119.768 24.3307 120.862 25.297 121.699 26.4701C122.536 27.6432 123.095 28.9921 123.331 30.4138C123.567 31.8355 123.476 33.2924 123.063 34.6733C121.344 40.4524 119.914 47.6108 120.531 54.2768L100.885 60.8998Z",
    fill: "#5B6B78"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.675 35.2397C117.135 32.9241 116.101 30.7674 114.366 30.4225C112.63 30.0775 110.85 31.6751 110.39 33.9906C109.93 36.3062 110.964 38.463 112.699 38.8079C114.435 39.1528 116.215 37.5553 116.675 35.2397Z",
    fill: "#CCD6DB",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.246 28.6246C107.691 27.2219 108.457 25.9423 109.484 24.8876C110.51 23.8328 111.768 23.032 113.158 22.5486C111.295 22.7095 109.521 23.4189 108.06 24.5873C106.6 25.7556 105.518 27.3305 104.952 29.113C100.885 41.9528 100.869 60.8998 100.869 60.8998L103.151 60.1183C103.186 57.7543 103.468 40.5578 107.246 28.6246Z",
    fill: "#6C7A85",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.246 28.6246C107.691 27.2219 108.457 25.9423 109.484 24.8876C110.51 23.8328 111.768 23.032 113.158 22.5486C111.295 22.7095 109.521 23.4189 108.06 24.5873C106.6 25.7556 105.518 27.3305 104.952 29.113C100.885 41.9528 100.869 60.8998 100.869 60.8998L103.151 60.1183C103.186 57.7543 103.468 40.5578 107.246 28.6246Z",
    fill: "#A6B3BC",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.126 91.2056C157.729 76.1504 146.327 65.2135 141.638 61.0678C141.005 60.5102 140.233 60.1338 139.404 59.9784C138.574 59.823 137.718 59.8943 136.926 60.1847L115.939 67.9214C115.939 67.9214 134.828 82.9297 145.511 105.003L163.75 97.8365C164.37 97.5911 164.931 97.2164 165.394 96.7373C165.857 96.2583 166.213 95.6859 166.438 95.0584C166.663 94.431 166.752 93.7627 166.698 93.0984C166.644 92.434 166.449 91.7887 166.126 91.2056Z",
    fill: "#6C7A85",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.988 182.498C155.843 132.874 130.519 99.3839 110.868 82.4688C110.868 82.4922 126.599 125.267 116.729 135C106.859 144.733 94.0664 136.735 94.0664 136.735C100.224 153.033 111.888 169.502 132.988 182.498Z",
    fill: "#5B6B78"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3901 69.5234C92.3901 69.5234 68.0313 142.486 132.988 182.498C167.463 107.675 92.3901 69.5234 92.3901 69.5234Z",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.064 131.397C108.434 153.474 133.004 182.498 133.004 182.498C133.004 182.498 130.714 121.758 127.659 100.724",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.305 102.725L149.457 99.4816L148.117 97.2974L142.975 98.4344C142.975 98.4344 142.998 99.2159 143.041 100.271C143.901 101.81 144.729 103.397 145.511 105.003L151.305 102.725Z",
    fill: "#162D3C",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.939 67.9214L122.41 62.959C123.287 62.2894 124.373 61.9532 125.474 62.0104C126.576 62.0677 127.621 62.5147 128.424 63.2716C133.675 68.2301 144.889 79.4678 152.626 91.8543C153.264 92.8847 153.474 94.1233 153.212 95.3063C152.95 96.4893 152.236 97.5234 151.223 98.1882C148.855 99.7512 146.144 102.123 145.511 105.003C145.511 105.003 135.551 83.8558 115.939 67.9214Z",
    fill: "#A6B3BC",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.035 83.5042C172.035 83.5042 176.181 121.043 158.957 121.855L177.322 133.355L185.137 110.981L182.636 90.4554L172.035 83.5042Z",
    fill: "#5B6B78"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M196.326 204.079L184.338 180.92C183.353 178.748 181.944 176.795 180.192 175.177C178.44 173.559 176.383 172.309 174.14 171.499C164.57 168.002 156.67 158.515 152.586 148.312C147.604 135.848 139.235 142.451 134.249 134.066C129.263 125.681 135.316 115.369 146.889 116.795C158.463 118.222 164.863 130.682 170.572 120.355C176.281 110.028 175.914 91.1549 175.914 91.1549C175.914 91.1549 170.529 79.8508 166.766 75.8887C166.766 75.8887 188.109 69.5235 194.341 92.5811C194.341 92.5811 206.27 90.5336 209.834 109.852C209.834 109.852 217.309 109.141 219.536 117.596C221.763 126.052 221.048 130.952 226.749 138.606C232.45 146.261 249.553 171.257 249.553 171.257L196.326 204.079Z",
    fill: "#A0D4E8",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M226.766 138.606C221.065 130.952 221.78 126.056 219.553 117.596C217.326 109.137 209.851 109.852 209.851 109.852C206.287 90.5335 194.358 92.581 194.358 92.581C192.662 86.3057 189.849 82.2146 186.649 79.5771C194.522 94.4253 192.51 112.255 193.022 123.731C193.533 135.207 212.254 152.962 198.363 161.656C189.376 167.291 159.605 160.382 159.605 160.382C163.614 165.415 168.593 169.463 174.157 171.491C176.4 172.301 178.458 173.551 180.209 175.17C181.961 176.788 183.37 178.74 184.355 180.912L196.343 204.071L249.57 171.249C249.57 171.249 232.447 146.265 226.766 138.606Z",
    fill: "#60B7D8"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.334 92.5811C194.334 92.5811 196.116 101.306 196.651 106.378",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M209.834 109.852C209.834 109.852 210.412 114.123 210.678 115.994",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M231.513 202.316C246.509 193.658 255.069 180.41 250.632 172.725C246.195 165.04 230.441 165.829 215.446 174.487C200.45 183.145 191.89 196.393 196.327 204.078C200.763 211.763 216.517 210.974 231.513 202.316Z",
    fill: "#79B9CC",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M231.513 202.316C246.509 193.658 255.069 180.41 250.632 172.725C246.195 165.04 230.441 165.829 215.446 174.487C200.45 183.145 191.89 196.393 196.327 204.078C200.763 211.763 216.517 210.974 231.513 202.316Z",
    fill: "#60B7D8"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M231.513 202.316C246.509 193.658 255.069 180.41 250.632 172.725C246.195 165.04 230.441 165.829 215.446 174.487C200.45 183.145 191.89 196.393 196.327 204.078C200.763 211.763 216.517 210.974 231.513 202.316Z",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.669 148.578C75.669 148.578 96.3783 146.042 102.509 138.81C108.64 131.577 104.779 121.449 94.6317 121.851C84.4841 122.254 67.9245 126.353 58.9766 108.41",
    fill: "#A0D4E8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.669 148.578C75.669 148.578 96.3783 146.042 102.509 138.81C108.64 131.577 104.779 121.449 94.6317 121.851C84.4841 122.254 67.9245 126.353 58.9766 108.41",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0234 164.337C46.0234 164.337 65.6543 169.944 75.6689 148.578",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100.885 140.384L132.589 129.58",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M139.259 165.263C135.008 167.795 132.464 164.309 132.464 164.309C129.436 170.17 121.43 167.65 121.43 167.65C121.43 167.65 123.212 173.187 120.539 173.57",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.856 157.956C135.534 160.832 131.979 155.439 131.979 155.439C128.642 162.215 115.063 158.612 115.063 158.612C115.063 158.612 115.708 164.809 112.172 165.696",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M141.935 148.578C135.734 149.586 130.994 143.108 130.994 143.108C124.008 152.161 108.667 148.578 108.667 148.578C108.667 148.578 107.886 155.58 104.818 156.784",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M132.987 182.549C132.987 182.549 131.424 182.655 131.424 186.031V229.2",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.316 233.385C141.482 227.755 138.057 222.287 132.666 221.17C127.275 220.054 121.96 223.712 120.794 229.342C119.629 234.971 123.054 240.44 128.444 241.556C133.835 242.673 139.15 239.014 140.316 233.385Z",
    fill: "#6C7A85",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.261 244.775C123.92 244.775 126.075 242.283 126.075 239.21C126.075 236.137 123.92 233.646 121.261 233.646C118.603 233.646 116.447 236.137 116.447 239.21C116.447 242.283 118.603 244.775 121.261 244.775Z",
    fill: "white",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M134.871 240.183C134.871 240.183 137.45 252.546 134.578 256.954",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M126.995 248.569C131.352 248.569 134.884 245.037 134.884 240.68C134.884 236.323 131.352 232.791 126.995 232.791C122.638 232.791 119.105 236.323 119.105 240.68C119.105 245.037 122.638 248.569 126.995 248.569Z",
    fill: "#6C7A85",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M131.121 244.775C133.779 244.775 135.934 242.283 135.934 239.21C135.934 236.137 133.779 233.646 131.121 233.646C128.462 233.646 126.307 236.137 126.307 239.21C126.307 242.283 128.462 244.775 131.121 244.775Z",
    fill: "white",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M122.469 244.407C122.469 244.407 124.387 246.087 126.306 244.407",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120.249 244.775C119.332 245.805 118.059 246.451 116.686 246.582C115.313 246.714 113.941 246.323 112.845 245.486L110 243.309",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M136.797 235.983C136.797 235.983 143.873 241.727 141.74 249.538",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M138.137 232.646C138.137 232.646 146.565 236.112 146.768 244.208",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M138.137 228.508C140.331 229.012 142.365 230.058 144.05 231.552C145.734 233.046 147.017 234.939 147.78 237.057",
    stroke: "#162D3C",
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M114.928 195.373C115.906 195.373 116.698 194.581 116.698 193.603C116.698 192.626 115.906 191.833 114.928 191.833C113.951 191.833 113.158 192.626 113.158 193.603C113.158 194.581 113.951 195.373 114.928 195.373Z",
    fill: "#162D3C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M146.03 213.187C147.007 213.187 147.8 212.395 147.8 211.417C147.8 210.439 147.007 209.647 146.03 209.647C145.052 209.647 144.26 210.439 144.26 211.417C144.26 212.395 145.052 213.187 146.03 213.187Z",
    fill: "#162D3C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5784 204.962C98.0661 204.962 98.4615 204.567 98.4615 204.079C98.4615 203.591 98.0661 203.196 97.5784 203.196C97.0907 203.196 96.6953 203.591 96.6953 204.079C96.6953 204.567 97.0907 204.962 97.5784 204.962Z",
    fill: "#162D3C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5909 179.451C100.637 179.451 102.295 177.792 102.295 175.746C102.295 173.701 100.637 172.042 98.5909 172.042C96.5452 172.042 94.8867 173.701 94.8867 175.746C94.8867 177.792 96.5452 179.451 98.5909 179.451Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M149.735 197.757C151.051 197.757 152.119 196.69 152.119 195.373C152.119 194.057 151.051 192.99 149.735 192.99C148.419 192.99 147.352 194.057 147.352 195.373C147.352 196.69 148.419 197.757 149.735 197.757Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.30bffa7dfafe495a11762b3be576414d.svg";
export { ForwardRef as ReactComponent };